import React, { useState, useEffect } from "react"
import { Col, Row, Input, Button, Spin, message } from 'antd'
import { UserOutlined, CaretRightOutlined, LoadingOutlined } from '@ant-design/icons';
import { login } from "../../api/User/LoginMethod"
import { useNavigate, useLocation } from "react-router-dom";
import './login.css'
import logo from "./../../assets/image003.jpeg"

function Login() {
  const [username, setUsername] = useState<string>("")
  const [password, setPassword] = useState<string>("")
  const [error, setError] = useState<string>("")
  const [loading, setLoading] = useState<boolean>(false)
  const [isSSO, setIsSSO] = useState<boolean>(window.location.host === "hiris.datakeen.co" ? true : false)
  const navigate = useNavigate()
  const location: any = useLocation()

  useEffect(() => {
    if (location.state && location.state.error) {
      message.error({ content: location.state.error, duration: 0, key: "error.message.sso" })
    }
  })

  const handleLogin = async () => {
    if (window.location.host === "hiris.datakeen.co" && isSSO)
      window.location.replace("https://hiris.datakeen.co/backend/login")
    else if (window.location.host === "hiris-dev.datakeen.co" || window.location.host === 'localhost:3000' || !isSSO) {
      const res: { message: string, jwt: { accessToken: string, refreshToken: string }, user: any } | undefined = await login(username, password)
      if (!res) {
        setError("Mauvais identifiant ou mot de passe")
        setLoading(false)
        return
      }
      localStorage.setItem("token", JSON.stringify(res.jwt))
      localStorage.setItem("user", JSON.stringify(res.user))
      if (res.jwt) {
        setError('')
        navigate("/home")
      } else {
        setError("Mauvais identifiant")
      }
    }
  }

  return (
    <Row className="login-card">
      <Col xs={24} className='login-logo-div'>
        <img src={logo} alt="logo" className="login-logo" />
      </Col>
      {!isSSO ?
        <>
          <Col>Tapez vos identifiant pour vous connecter</Col>
          <Col xs={24} className='login-input'>
            <Input
              onChange={(e) => setUsername(e.target.value)}
              id={"username"}
              size="large"
              placeholder="Nom d'utilisateur"
              prefix={<UserOutlined />} />
          </Col>
          <Col xs={24} className="login-input">
            <Input
              prefix={<CaretRightOutlined />}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              id={"password"}
              size="large"
              placeholder="Mot de passe" />
          </Col>
          <Col>
            <Spin spinning={loading} indicator={<LoadingOutlined />}>
              <Button id="login-button" className="login-button" onClick={() => handleLogin()}>Se connecter</Button>
            </Spin>
            <div className="login-error" id="login-error">{error}</div>
          </Col>
          <Col xs={24} style={{ paddingTop: "2rem" }}>
            <span onClick={() => setIsSSO(true)}><a>se connecter en SSO</a></span>
          </Col>
        </>
        :
        <>
          <Col xs={24}>
            <Button className="login-sso-button" size="large" onClick={() => handleLogin()}>Se connecter en SSO</Button>
          </Col>
          <Col>
            <span onClick={() => setIsSSO(false)}><a>ou utiliser une adresse e-mail</a></span>
          </Col>
        </>
      }
    </Row>
  )
}

export default Login